// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://bgvtizcnkexnctzeieqa.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJndnRpemNua2V4bmN0emVpZXFhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTg0NDE1MTEsImV4cCI6MjA3NDAxNzUxMX0.0lmfrjA34lOwxHQFPhaQw-XRUBWf6com6aSLCoyhItQ";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});